import { RadioVariants } from './types';
import styles from './Radio.module.scss';

export const getHintStyle = (variant: RadioVariants) => {
    return styles[`radio-content__hint--${variant}`];
};
